module.exports = __webpack_public_path__ + "static/media/progress-chart-icon.f2b21a9f.svg";